<template>
  <div>
    <div class="header-top">
      <div class="content">
        <div class="pull-left">
          <span style="color: #666">您好！欢迎来到小橙家教网！</span>
          <span v-if="loginStatus">{{ nick_name }}</span>
          <router-link
            v-if="!loginStatus"
            class="go-login"
            :to="{ name: 'UserLogin' }"
          >
            请登录
          </router-link>
          <div class="vertical-line" />
          <router-link
            v-if="!loginStatus"
            class="go-register"
            :to="{ name: 'UserRegister' }"
          >
            免费注册
          </router-link>
          <a
            v-if="loginStatus"
            style="margin-left: 10px"
            href="javascript:;"
            @click="logout"
            >退出</a
          >
        </div>
        <div class="pull-right" style="position: relative">
          <span
            class="weixin-text"
            @mouseover="weixinMouseOver"
            @mouseleave="weixinMouseLeave"
            >小橙家教微信</span
          >
          <div
            class="weixin-icon"
            @mouseover="weixinMouseOver"
            @mouseleave="weixinMouseLeave"
          />
          <div
            v-if="false"
            style="float: right; margin-left: 10px; margin-right: 10px"
            class="vertical-line"
          />
          <span
            v-if="false"
            class="weibo-text"
            @mouseover="weiboMouseOver"
            @mouseleave="weiboMouseLeave"
            >小橙家教微博</span
          >
          <div
            v-if="false"
            class="weibo-icon"
            @mouseover="weiboMouseOver"
            @mouseleave="weiboMouseLeave"
          />
        </div>
        <div class="weixin-weibo">
          <img
            v-show="weixinCodeShow"
            class="weixin-img"
            src="@/assets/wx-public.png"
            alt="小橙家教微信"
          />
          <img
            v-show="weiboCodeShow"
            class="weibo-img"
            src="@/assets/wx-public.png"
            alt="小橙家教微博"
          />
        </div>
      </div>
    </div>
    <div class="header">
      <div class="container">
        <div class="pull-left">
          <complete-logo style="float: left; margin-right: 40px" />
          <router-link
            class="menu"
            :class="page_type === 'index' ? 'select' : ''"
            :to="{ name: 'Index' }"
          >
            首页
          </router-link>
          <router-link
            class="menu"
            :class="page_type === 'tutor' ? 'select' : ''"
            :to="{ name: 'TutorList' }"
          >
            找家教
          </router-link>
          <router-link
            class="menu"
            :class="page_type === 'reveal' ? 'select' : ''"
            :to="{ name: 'RevealList' }"
          >
            教员风采
          </router-link>
          <router-link
            class="menu"
            :class="page_type === 'forum' ? 'select' : ''"
            :to="{ name: 'ForumList' }"
          >
            家教论坛
          </router-link>
          <router-link
            class="menu"
            :class="page_type === 'helps' ? 'select' : ''"
            :to="{ name: 'HeplsCategory', params: { id: 1 } }"
          >
            帮助中心
          </router-link>
          <router-link
            class="menu"
            :class="page_type === 'announce' ? 'select' : ''"
            :to="{ name: 'NewsList' }"
          >
            新闻公告
          </router-link>
          <router-link
            v-if="accountType == 'teacher'"
            class="menu"
            :class="page_type === 'teacher' ? 'select' : ''"
            :to="{ name: 'TeacherInfo' }"
          >
            个人中心
          </router-link>
          <router-link
            v-if="accountType == 'user'"
            class="menu"
            :class="page_type === 'user' ? 'select' : ''"
            :to="{ name: 'UserInfo' }"
          >
            个人中心
          </router-link>
        </div>
        <div class="pull-right">
          <a-icon
            theme="filled"
            class="theme-color"
            style="font-size: 15px"
            type="environment"
          />
          <span
            class="theme-color"
            style="margin-left: 5px; font-size: 16px; cursor: pointer"
            @click="goChangeCity"
            >{{ region }}</span
          >
          <router-link
            style="color: #666666; margin-left: 20px"
            :to="{ name: 'ChangeCity' }"
          >
            <span>【切换城市】</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CompleteLogo } from '@/components'
import { mapActions } from 'vuex'

export default {
  name: 'MainHeader',
  components: {
    CompleteLogo
  },
  props: {
    page_type: {
      type: String,
      default: 'index'
    }
  },
  data() {
    return {
      weixinCodeShow: false,
      weiboCodeShow: false,
      accountType: undefined,
      nick_name: '',
      loginStatus: false
    }
  },
  computed: {
    region() {
      return this.$store.getters.region
    }
  },
  created() {
    this.accountType = this.$store.getters.accountType
    this.nick_name = this.$store.getters.userInfo.nick_name
      ? this.$store.getters.userInfo.nick_name
      : ''
    if (this.nick_name !== '') {
      this.loginStatus = true
    }
  },
  methods: {
    ...mapActions(['TeacherLogout', 'UserLogout']),
    goChangeCity() {
      this.$router.push({ name: 'ChangeCity' })
    },
    logout() {
      if (this.accountType === 'user') {
        this.UserLogout().then(() => {
          this.$notification.success({
            message: 'success',
            description: '退出账户成功'
          })
          setTimeout(() => {
            location.reload()
          }, 1000)
        })
      } else {
        this.TeacherLogout().then(() => {
          this.$notification.success({
            message: 'success',
            description: '退出账户成功'
          })
          setTimeout(() => {
            location.reload()
          }, 1000)
        })
      }
    },
    weixinMouseOver() {
      this.weixinCodeShow = true
    },
    weixinMouseLeave() {
      this.weixinCodeShow = false
    },
    weiboMouseOver() {
      this.weiboCodeShow = true
    },
    weiboMouseLeave() {
      this.weiboCodeShow = false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

.logo {
  height: 50px;
}

.vertical-line {
  content: '';
  height: 14px;
  width: 1px;
  border-radius: 1px;
  float: left;
  margin-top: 13px;
  margin-left: 10px;
  background-color: #eeeeee;
}

.header-top {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  // overflow hidden

  .content {
    width: $container-width;
    height: 100%;
    margin: auto;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;

    .pull-left {

      span {
        float: left;
      }

      .go-login {
        float: left;
        width: 43px;
        font-family: MicrosoftYaHeiLight;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }

      .go-register {
        float: left;
        width: 56px;
        font-family: MicrosoftYaHeiLight;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: $theme-color;
        margin-left: 10px;
      }
    }

    .pull-right {
      cursor pointer
      .weibo-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('../../assets/all-custom-icon.svg') no-repeat;
        /*显示剩余的部分，向左移动60px*/
        background-position:0px -28px;
        background-repeat: no-repeat;
        -webkit-background-size: cover;/* 兼容Webkit内核浏览器如Chrome和Safari */
        -o-background-size: cover;/* 兼容Opera */

        float: right;
        margin-top: 10px;
      }

      .weixin-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('../../assets/all-custom-icon.svg') no-repeat;
        /*显示剩余的部分，向左移动60px*/
        background-position:0px 0px;
        background-repeat: no-repeat;
        -webkit-background-size: cover;/* 兼容Webkit内核浏览器如Chrome和Safari */
        -o-background-size: cover;/* 兼容Opera */

        float: right;
        margin-top: 10px;
      }

      span {
        float: right;
        margin-left: 5px;
      }
    }

    // 微信微博二维码
    .weixin-weibo {
      float: right;
      position relative;

      .weixin-img {
        width: 110px;
        height: 110px;
        position: absolute;
        right: -110px;
        top: 34px;
        z-index: 4;
      }

      .weibo-img {
        position: absolute;
        right: -107px;
        top: 34px;
        z-index: 4;
      }
    }
  }
}

.header {
  width: 100%;
  height: 60px;
  background-color: #fff;
  // box-shadow: 0px 3px 7px 0px rgba(216, 216, 216, 0.3);

  .container {
    width: $container-width;
    height: 60px;
    margin: auto;
    line-height: 60px;
    overflow: hidden;
    padding-right: 10px;
    border-top: 1px solid #eeeeee;

    .pull-left {
      .menu {
        margin-right: 50px;
        color: #333333;
        font-weight: normal;
        font-stretch: normal;
        font-size: 14px;

        &:hover {
          color: $theme-color;
        }
      }

      .select {
        color: $theme-color
      }
    }

    .link-jump-title {
      width: 64px;
      height: 16px;
      font-family: MicrosoftYaHeiLight;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 25px;
      letter-spacing: 0px;
      color: #fa750d;
    }
  }
}
</style>
